import React, { useState } from 'react';
import { Button, FormControl, Grid, IconButton, InputAdornment, InputLabel, OutlinedInput, TextField } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Link, useHistory } from 'react-router-dom';  
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { Constants } from '../../endPoints';

export default function Login() {
  const history = useHistory();  
  const backgroundImageUrl = 'assets/images/bg-02.jpg';
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState('');  
  const [password, setPassword] = useState('');  

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => event.preventDefault();

  const [resetModal, setResetModal] = useState(false);
  const [resetUsername, setResetUsername] = useState(''); // State for reset username
  const resetOpen = () => setResetModal(true);
  const resetClose = () => setResetModal(false);

  const handleLogin = async (event) => {
    event.preventDefault();

    try {
        const response = await fetch(Constants.userLogin, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email, password }), 
        });

        if (!response.ok) {
            const errorData = await response.json();
            console.error('Login failed', errorData);
            alert(errorData.message || 'Login failed, please try again.');  
            return;
        }

        const data = await response.json();
        console.log(data);
        // Store tokens in local storage
        localStorage.setItem('authToken', data.accessToken); // Store the accessToken under authToken key
        localStorage.setItem('refreshToken', data.refreshToken);
        window.location.href = '/dashboard';
    } catch (error) {
        console.error('Network error', error);
        alert('A network error occurred. Please try again later.');
    }
};

  return (
    <>
      <section className='bgleft relative min-h-screen'>
        <div className='mx-auto min-h-screen align-items-center'>
          <Grid container columns={12} spacing={0} className='overflow-hidden h-full min-h-screen'>
            <Grid item lg={6} sm={12} xs={12} style={{backgroundImage: `url(${backgroundImageUrl})`}} className='bg-cover bg-right-top table'>
              <div className='align-middle table-cell py-10 relative boxlayer'>
                <div className='absolute top-0 left-0 w-full h-full bg-[#ffffff21]'></div>
                <Grid container spacing={3} className='justify-center'>
                  <Grid item lg={6}>
                    <div className='text-center relative z-[1]'>
                      <img src='assets/images/logo.svg' className='mx-auto h-20' alt="Logo"/>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </Grid>
            <Grid item lg={6} sm={12} xs={12} className='table'>
              <div className='align-middle table-cell py-14 px-6'>
                <Grid container spacing={3} className='justify-center'>
                  <Grid item xl={6} lg={7} md={8} xs={12}>
                    <h2 className='mb-8 text-4xl font-semibold text-center headningfont'>Log In</h2>
                    <form onSubmit={handleLogin}>
                      <div className='mb-5'>
                        <TextField 
                          label="Email" 
                          variant="outlined" 
                          className='w-full rounded-lg'
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                        />
                      </div>
                      <div className='mb-5'>
                        <FormControl variant="outlined" className='w-full'>
                          <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel>
                          <OutlinedInput
                            id="outlined-adornment-password"
                            type={showPassword ? 'text' : 'password'}
                            endAdornment={
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={handleClickShowPassword}
                                  onMouseDown={handleMouseDownPassword}
                                  edge="end"
                                >
                                  {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                            }
                            label="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                          />
                        </FormControl>
                      </div>
                      <div className='mb-5 text-center'>
                        <Link to="#" onClick={resetOpen} className="text-[#A27800] font-semibold underline">Forgot Your Password?</Link>
                      </div>
                      <div className='mb-5'>
                        <button type="submit" className='w-full h-[54px] shadow-0 bg-[#A27800] rounded-full text-white font-semibold hover:bg-black transition-all'>Login</button>
                      </div>
                      
                      <div className='mt-10 text-center'>
                        <p className='mb-4'>Do not have an account?</p>
                        <Link to="/register" className='block text-center leading-[54px] w-full h-[54px] shadow-0 bg-[#A27800] rounded-full text-white font-semibold hover:bg-black transition-all'>Register</Link>
                      </div>
                    </form>
                  </Grid>
                </Grid>
              </div>
            </Grid>
          </Grid>
        </div>
      </section>

      <Modal 
        open={resetModal}
        onClose={resetClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modal md:w-[500px] w-[90%] bg-[#F8FFFC] md:p-14 p-6 rounded-2xl">
          <h2 className='md:text-2xl text-xl font-bold text-center mb-5'>Reset password</h2>
          <p className='text-center mb-10'>If you're looking for how to reset a password using an email, here's some information</p>
          <div className='mb-10'>
            <form>
              <div className='mb-5'>
                <TextField 
                  label="Username / Email" 
                  variant="outlined" 
                  className='w-full rounded-lg' 
                  value={resetUsername}
                  onChange={(e) => setResetUsername(e.target.value)} 
                  required
                />
              </div>
              <div className="mb-5">
                <button type="button" className="w-full h-[54px] shadow-0 bg-[#A27800] rounded-full text-white font-semibold hover:bg-black transition-all">Reset</button>
              </div>
            </form>
          </div>
          <div className='text-center'>
            <Link to="#" onClick={resetClose} className="underline text-[#A27800]">Close</Link>
          </div>
        </Box>
      </Modal>
    </>
  );
}
